import { loadStations, loadDailySummary, loadMonthlySummary, loadReadingsData } from '../../api/telemetry';
import {loadSuppliedInhabitants, loadUnSuppliedInhabitants} from '../../api/etas/supplied-inhabitants.api';
import {loadCurrentDemand, loadSavedDemand} from '../../api/etas/current-demand.api';
import {loadRulerImageInfo, getRulerImageUrl} from '../../api/riak/ruler-image.api';

import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  usefulVolume: undefined,
  usefulVolumePercentage: undefined,
  usefulVolumeSaic: undefined,
  usefulVolumePercentageSaic: undefined,
  levelUnderSpillway: undefined,
  saicStations: undefined,
  suppliedInhabitants: undefined,
  unSuppliedInhabitants: undefined,
  currentDemand: undefined,
  savedDemand: undefined,
  reservoirTendency: [],
  alertCota: undefined,
  sensor351Data: undefined,
  rulerImageInfo: undefined,
};

const mutations = {
  setUsefulVolume(state, data){
    state.usefulVolume = data;
  },
  setUsefulVolumePercentage(state, data){
    state.usefulVolumePercentage = data;
  },
  setUsefulVolumeSaic(state, data){
    state.usefulVolumeSaic = data;
  },
  setUsefulVolumePercentageSaic(state, data){
    state.usefulVolumePercentageSaic = data;
  },
  setLevelUnderSpillway(state, data){
    state.levelUnderSpillway = data;
  },
  setSaicStations(state, data){
    state.saicStations = data;
  },
  setSuppliedInhabitants(state, data){
    state.suppliedInhabitants = data;
  },
  setUnSuppliedInhabitants(state, data){
    state.unSuppliedInhabitants = data;
  },
  setCurrentDemand(state, data){
    state.currentDemand = data;
  },
  setSavedDemand(state, data){
    state.savedDemand = data;
  },
  setReservoirTendency(state, data){
    state.reservoirTendency = data ? data : [];
  },
  setAlertCota(state, data){
    state.alertCota = data ? data : {};
  },
  setSensor351Data(state, data){
    state.sensor351Data = data;
  },
  setRulerImageInfo(state, data){
    state.rulerImageInfo = data;
  },
};

const actions = {
  async loadUsefulVolume( {commit}, data){
    try{
      const { type } = data;
      let response = {};
      if(type === "daily") response = await loadDailySummary({ ...data });
      else{
        const monthlyReponse = await loadMonthlySummary({ ...data });
        response.data = monthlyReponse.data.map((result) => {
          const { ano, mes } = result;
          return { ...result, data: `${ano}-${mes}`};
        })
      }
      commit('setUsefulVolume', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do volume útil.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setUsefulVolume', undefined);
    }
  },

  async loadUsefulVolumePercentage({commit}, data){
    try{
      const { type } = data;
      let response = {};
      if(type === "daily") response = await loadDailySummary({ ...data });
      else{
        const monthlyReponse = await loadMonthlySummary({ ...data });
        response.data = monthlyReponse.data.map((result) => {
          const { ano, mes } = result;
          return { ...result, data: `${ano}-${mes}`};
        })
      }
      commit('setUsefulVolumePercentage', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do volume útil percentual.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setUsefulVolumePercentage', undefined);
    }
  },

  async loadUsefulVolumeSaic({commit}, data){
    try{
      const { type } = data;
      let response = {};
      if(type === "daily") response = await loadDailySummary({ ...data });
      else{
        const monthlyReponse = await loadMonthlySummary({ ...data });
        response.data = monthlyReponse.data.map((result) => {
          const { ano, mes } = result;
          return { ...result, data: `${ano}-${mes}`};
        })
      }
      commit('setUsefulVolumeSaic', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do volume útil SAIC.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setUsefulVolumeSaic', undefined);
    }
  },

  async loadUsefulVolumePercentageSaic({commit}, data){
    try{
      const { type } = data;
      let response = {};
      if(type === "daily") response = await loadDailySummary({ ...data });
      else{
        const monthlyReponse = await loadMonthlySummary({ ...data });
        response.data = monthlyReponse.data.map((result) => {
          const { ano, mes } = result;
          return { ...result, data: `${ano}-${mes}`};
        })
      }
      commit('setUsefulVolumePercentageSaic', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do volume útil percentual SAIC`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setUsefulVolumePercentageSaic', undefined);
    }
  },

  async loadLevelUnderSpillway({commit}, data){
    try{
      const { type } = data;
      let response = {};
      if(type === "daily") response = await loadDailySummary({ ...data });
      else{
        const monthlyReponse = await loadMonthlySummary({ ...data });
        response.data = monthlyReponse.data.map((result) => {
          const { ano, mes } = result;
          return { ...result, data: `${ano}-${mes}`};
        })
      }
      commit('setLevelUnderSpillway', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do nível sob o vertedouro`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setLevelUnderSpillway', undefined);
    }
  },


  async loadSaicStations({commit}, data){
    try{
      const { station_ids } = data;
      const response = await loadStations({ station_ids });
      commit('setSaicStations', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das estações SAIC`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSaicStations', undefined);
    }
  },

  async loadSuppliedInhabitants({commit}, data){
    try{
      const {period, type} = data;
      const response = await loadSuppliedInhabitants(period, type);
      commit('setSuppliedInhabitants', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos habitantes supridos`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSuppliedInhabitants', undefined);
    }
  },

  async loadUnSuppliedInhabitants({commit}, data){
    try{
      const {period, type} = data;
      const response = await loadUnSuppliedInhabitants(period, type);
      commit('setUnSuppliedInhabitants', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos habitantes mão supridos`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setUnSuppliedInhabitants', undefined);
    }
  },

  async loadCurrentDemand({commit}, data){
    try{
      const {period, type} = data;
      const response = await loadCurrentDemand(period, type);
      commit('setCurrentDemand', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações da demanda atual`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setCurrentDemand', undefined);
    }
  },

  async loadSavedDemand({commit}, data){
    try{
      const {period, type} = data;
      const response = await loadSavedDemand(period, type);
      commit('setSavedDemand', response.data);
    }catch(error){
      commit('setSavedDemand', undefined);
    }
  },

  async loadReservoirTendency( {commit}, payload ){
    try{
      const {datai, dataf, estacoes, sensores, operacoes} = payload;
      const response = await loadDailySummary({date_start: datai, date_end: dataf, station_ids: estacoes, sensor_ids: sensores, operation_ids: operacoes});
      commit('setReservoirTendency', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações da demanda salva`,
        type: "error",
        duration: 5000,
        dismissible: true
      });

      commit('setReservoirTendency', undefined);
    }
  },

  async loadSensor351Data({commit}){
    try{
      const moment = require('moment');
      const datetime_start = moment().subtract(1, 'days').utc().format();
      const datetime_end = moment().utc().format();

      const response = await loadReadingsData({
        station_ids: "25484909",
        sensor_ids: "351",
        datetime_start,
        datetime_end
      });

      if(response.data && response.data.length > 0){
        commit('setSensor351Data', response.data[0]);
      } else {
        commit('setSensor351Data', undefined);
      }
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do sensor 351`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSensor351Data', undefined);
    }
  },

  async loadRulerImageInfo({commit}, stationId = "25484909"){
    try{
      const response = await loadRulerImageInfo(undefined, stationId);

      if(response.data){
        commit('setRulerImageInfo', {
          ...response.data,
          imageUrl: getRulerImageUrl(undefined, stationId)
        });
      } else {
        commit('setRulerImageInfo', {
          imageUrl: getRulerImageUrl(undefined, stationId),
          measurement_date: null
        });
      }
    }catch(error){
      commit('setRulerImageInfo', {
        imageUrl: getRulerImageUrl(undefined, stationId),
        measurement_date: null
      });
    }
  },
};

const getters = {
    usefulVolume: (state) => state.usefulVolume,
    usefulVolumePercentage: (state) => state.usefulVolumePercentage,
    usefulVolumeSaic: (state) => state.usefulVolumeSaic,
    usefulVolumePercentageSaic: (state) => state.usefulVolumePercentageSaic,
    levelUnderSpillway: (state) => state.levelUnderSpillway,
    saicStations: (state) => state.saicStations,
    suppliedInhabitants: (state) => state.suppliedInhabitants,
    unSuppliedInhabitants: (state) => state.unSuppliedInhabitants,
    currentDemand: (state) => state.currentDemand,
    savedDemand: (state) => state.savedDemand,
    reservoirTendency: (state) => state.reservoirTendency,
    alertCota: (state) => state.alertCota,
    sensor351Data: (state) => state.sensor351Data,
    rulerImageInfo: (state) => state.rulerImageInfo,
};

export default {
    state,
    mutations,
    actions,
    getters
}
